import type { CalculationResult } from '#calculator'

import type { ChartPayload } from '.'

export type { ChartPayload }

export const calculationResultToChartsPayload = (
  results: CalculationResult[],
  startYear: number,
  ageAtStart: number
): ChartPayload => {
  const payload: ChartPayload = {
    isEmpty: true,
    wealth: [],
    cashflow: [],
    milestones: [],
  }
  let outOfMoneyDetected = false

  for (const result of results) {
    if (result.year < startYear) continue

    const age = String(ageAtStart + (result.year - startYear))
    const {
      assets,
      liabilities,
      income,
      expenses,
      incomeTaxes,
      contributions,
      liquidAssets,
    } = result.aggregatedData

    payload.isEmpty = false

    payload.wealth.push({
      age,
      year: result.year,
      networth: assets.totalValue - liabilities.totalValue,
      liquidAssets: liquidAssets.totalValue,
    })

    payload.cashflow.push({
      age,
      year: result.year,
      income: income.totalValue,
      expenses: expenses.totalValue,
      contributions: contributions.totalValue,
      incomeTaxes: incomeTaxes.totalValue,
    })

    if (!outOfMoneyDetected && liquidAssets.totalValue <= 0) {
      payload.milestones.push({
        age,
        label: 'Out of Money',
        kind: 'outOfMoney',
        chart: 'wealth',
        severity: 'danger',
      })
      outOfMoneyDetected = true
    }
  }

  return payload
}
